import { store } from "../store/store";
import { performLogout } from "./logoutSession";

let logoutInProgress = false;

/**
 * Clears session state and redirects to login when the API reports admin block.
 * Safe to call from concurrent failed requests (only runs once).
 */
export async function forceLogoutOnAdminBlock(): Promise<void> {
  if (logoutInProgress) {
    return;
  }
  logoutInProgress = true;

  try {
    await performLogout(store.dispatch);
  } finally {
    logoutInProgress = false;
  }
}
